import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
const InterestTag = ({ label, rating }) => {
    const theme = useTheme();
    return (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 0.5, sx: {
            bgcolor: '#FFF8E1',
            color: '#B78103',
            borderRadius: '8px',
            px: 1,
            py: 0.5,
            width: 'fit-content'
        }, children: [_jsxs(Typography, { variant: 'caption', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5, children: ["( ", _jsx(Icon, { icon: 'eva:star-fill', width: 14, height: 14 }), " ", rating, " )"] }), _jsx(Typography, { variant: 'caption', fontWeight: 600, children: label })] }));
};
export default InterestTag;
